import React, { useState, useEffect } from 'react';
import { bookingApi } from '../../utils/bookingApi';

// Live check of an unsaved routine against an upcoming competition category.
const RoutineRuleCheck = ({ gymnastId, apparatus, rows }) => {
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState('');
  const [slot, setSlot] = useState(1);
  const [result, setResult] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setCategoryId('');
    setResult(null);
    if (!gymnastId) { setCategories([]); return undefined; }
    bookingApi.categoriesForGymnast(gymnastId, apparatus)
      .then(res => { if (!cancelled) setCategories(res.data || []); })
      .catch(() => { if (!cancelled) setCategories([]); });
    return () => { cancelled = true; };
  }, [gymnastId, apparatus]);

  useEffect(() => {
    if (!categoryId) { setResult(null); setFailed(false); return undefined; }
    let cancelled = false;
    const timer = setTimeout(() => {
      const skills = rows.map(r => ({
        skillId: r.skillId || null,
        customSkillName: r.isImplicit ? r.name : null,
        difficulty: r.difficulty == null || r.difficulty === '' ? null : Number(r.difficulty),
      }));
      bookingApi.checkAgainstCategory(categoryId, { slot, skills })
        .then(res => { if (!cancelled) { setResult(res.data); setFailed(false); } })
        .catch(() => { if (!cancelled) { setResult(null); setFailed(true); } });
    }, 400);
    return () => { cancelled = true; clearTimeout(timer); };
  }, [categoryId, slot, rows]);

  if (categories.length === 0) return null;

  const unit = apparatus === 'DMT' ? 'pass' : 'routine';

  return (
    <div className="form-group routine-rule-check">
      <label htmlFor="routine-check-against">Check against</label>
      <div className="gymnast-routine-editor__row">
        <select id="routine-check-against" aria-label="Check against" className="form-control" value={categoryId} onChange={(e) => setCategoryId(e.target.value)}>
          <option value="">Don't check</option>
          {categories.map(c => (
            <option key={c.id} value={c.id}>{`${c.name} · ${c.eventName}${c.invited ? ' (invited)' : ''}`}</option>
          ))}
        </select>
        {categoryId && (
          <select aria-label="Check as" className="form-control" value={slot} onChange={(e) => setSlot(Number(e.target.value))}>
            <option value={1}>as {unit} 1</option>
            <option value={2}>as {unit} 2</option>
          </select>
        )}
      </div>
      {categoryId && failed && <p className="text-muted">Could not check just now.</p>}
      {categoryId && result && (result.ok ? (
        <p className="routine-rule-check__ok"><span aria-hidden="true">✓</span> Meets the requirements</p>
      ) : (
        <ul className="routine-rule-check__problems">
          {result.problems.map((p, i) => <li key={i}>{p.message}</li>)}
        </ul>
      ))}
    </div>
  );
};

export default RoutineRuleCheck;
